import http from "../utils/http";

export const getListBookings = (data) => {
  return http.post("/bookings/getListBookings", data);
};
export const getLatestDate = (data) => {
  return http.post("/bookings/latestDate", data);
};
export const getOldestDate = (data) => {
  return http.post("/bookings/oldestDate", data);
};
